<template>
  <v-content class="loginPage" style="background-color: #fafafa; margin-top: -120px">
    <DialogLoginFailed ref="dlgLoginFailed"></DialogLoginFailed>
    <v-container class="fill-height loginContainer" fluid style="max-width: 1280px">
      <v-row class="loginRow" align="center" justify="center">
        <v-col cols="12" md="8">
          <v-card class="mx-auto loginCard">
            <v-row>
              <v-col cols="12" xs="12" sm="6" class="py-0 justify-center">
                <v-card height="408"
                        color="black" class="hidden-xs-only">
                  <v-container fluid fill-height>
                    <v-layout align-center justify-center>
                      <v-img
                      height="auto"
                      width="150"
                      max-width="400"
                      src="/static/logo_kermax.png"
                      ></v-img>
                    </v-layout>
                  </v-container>
                </v-card>
                <v-card height="204"
                        color="black" class="hidden-sm-and-up loginMobileLogoCard">
                  <v-container fluid fill-height>
                    <v-layout align-center justify-center>
                      <v-img
                              class="loginMobileLogo"
                              height="auto"
                              width="350"
                              max-width="350"
                              src="/static/logo_kermax.png"
                      ></v-img>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-col>
              <v-col cols="12" xs="12" sm="6" class="py-0 justify-center">
                <v-container fluid fill-height>
                  <v-row
                  align="center"
                  justify="center"
                  >
                    <v-col cols="12" sm="12" md="12">

                      <v-card flat>
                        <v-card-text class="headline pl-1 quittetext font-weight-light loginTitle">
                          Anmelden
                        </v-card-text>
                        <v-row
                        align="center"
                        justify="end"
                        >
                          <v-col cols="12" sm="12" class="pr-4 loginFieldColumn" justify="end">
                            <v-text-field
                            outlined
                            color="#023b7e"
                            clearable
                            v-model="form.username"
                            :label="$t('loginUserNameLabel')"
                            type="text"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" class="pr-4 loginFieldColumn">
                            <div class="loginPasswordField">
                              <v-text-field
                              id="password"
                              v-model="form.password"
                              :label="$t('loginPasswordLabel')"
                              type="password"
                              color="#023b7e"
                              clearable
                              outlined
                              ></v-text-field>
                              <button
                                id="passwordToggle"
                                type="button"
                                class="loginPasswordToggle"
                                aria-label="Passwort anzeigen"
                                @click="toggleInput('password')"
                              >
                                <span id="passwordIcon" class="material-icons">visibility_off</span>
                              </button>
                            </div>
                          </v-col>
                        </v-row>
                        <v-card-actions class="loginActions">
                          <v-row
                          align="center"
                          justify="end"
                          >
                            <v-col cols="12" sm="6" class="pr-2 loginButtonColumn">
                              <v-btn dark color="black" block class="text-none" @click="doLogin()">{{'loginSubmit' | translate}}
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <span class="loginVersion">Version {{version}} vom {{versionDate}}</span>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import api from './Login.js'
import DialogLoginFailed from './../dialogs/DialogLoginFailed'

export default {
  name: 'Login',
  components: {DialogLoginFailed},
  data () {
    return {
      publicPath: process.env.BASE_URL,
      logo: null,
      version: '1',
      versionDate: '12.08.1975',
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    isStagingUser (data) {
      if (!data) return false

      var roleName = ''
      if (data.roleName) {
        roleName = '' + data.roleName
      } else if (data.role) {
        roleName = '' + data.role
      }

      var rights = data.rights || {}
      var hasStageRights = Boolean(
        rights.RIGHT_COMP_STAGE_UPLOAD_PICTURE ||
        rights.RIGHT_COMP_STAGE_IMG_VISIBLE ||
        rights.RIGHT_COMP_STAGE_CHANNELS_VISIBLE ||
        rights.RIGHT_COMP_STAGE_LAST_PING_VISIBLE ||
        rights.RIGHT_COMP_STAGE_STATISTIC_VISIBLE
      )

      return hasStageRights || roleName.toLowerCase() === 'stage'
    },
    buildSendeschleifeUrl (data) {
      var url = new URL(window.location.origin + '/offer/sendeschleife')
      var query = (this.$route && this.$route.query) ? this.$route.query : {}

      if (data && data.guidParent) {
        url.searchParams.set('companyGuid', data.guidParent)
      } else if (query.companyGuid) {
        url.searchParams.set('companyGuid', query.companyGuid)
      }

      if (data && data.authToken) {
        url.searchParams.set('authToken', data.authToken)
      }

      var passThroughKeys = ['token', 'code', 'offerId', 'advisoryId', 'provider', 'agencyId']
      for (var index in passThroughKeys) {
        var key = passThroughKeys[index]
        var value = query[key]
        if (typeof value === 'string' && value.length > 0 && !url.searchParams.has(key)) {
          url.searchParams.set(key, value)
        }
      }

      return url.toString()
    },
    getSafeOfferRedirect () {
      var redirect = this.$route && this.$route.query ? this.$route.query.redirect : null
      if (typeof redirect !== 'string') return null

      // Only authenticated Offer areas may use the hand-off from the
      // legacy login. This prevents an open redirect after authentication.
      if (!/^\/offer\/(admin|content-manager|sendeschleife)(?:[/?#]|$)/.test(redirect)) return null
      return redirect
    },
    onLoginFailed (data) {
      console.log('onLoginFailed', Vue.prototype.$api, data)
      this.$refs.dlgLoginFailed.open()
    },
    onLoginOk (data) {
      Vue.prototype.$eventHub.$emit('OnLogin', true)
      api.onLoginOk(data)
      var cmp = this
      console.log('push /Dashboard')
      var offerRedirect = this.getSafeOfferRedirect()
      if (offerRedirect) {
        window.location.assign(offerRedirect)
        return
      }
      if (data && data.redirectTo === '/content-manager') {
        window.location.assign('/offer/content-manager')
        return
      }
      if (data && data.redirectTo === '/admin') {
        window.location.assign('/offer/admin')
        return
      }
      if (this.isStagingUser(data)) {
        window.location.href = this.buildSendeschleifeUrl(data)
        return
      }
      if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_VISIBLE_DASHBOARD')) {
        cmp.$router.push('/Dashboard/MainLocation')
      } else {
        cmp.$router.push('/Dashboard')
      }
    },
    doLogin (data) {
      console.log('doLogin', Vue.prototype.$api, data)

      // var cmp = this
      // cmp.$router.push('/Dashboard')

      Vue.prototype.$api.credentials = null
      api.doLogin(this.form, this.onLoginOk, this.onLoginFailed)
      return true
    },
    toggleInput (a) {
      if ($('#' + a).attr('type') === 'password') {
        $('#' + a + 'Icon').html('visibility')
        $('#' + a).attr('type', 'text')
      } else {
        $('#' + a + 'Icon').html('visibility_off')
        $('#' + a).attr('type', 'password')
      }
    }
  },
  mounted () {
    const cmp = this
    Vue.prototype.$eventHub.$emit('OnLogin', false)
    this.version = Vue.prototype.$config.VERSION
    this.versionDate = Vue.prototype.$config.VERSION_DATE
    window.setTimeout(function () {
      cmp.form.password = Vue.prototype.$config.DEFAULT_PASSWORD
      cmp.form.username = Vue.prototype.$config.DEFAULT_USER
    },400)
    $('input').keypress(function (e) {
      if (e.which === 13) {
        cmp.doLogin()
        return false
      }
    })
  }
}
</script>


<style>

  #app {
    padding-top: 60px;
  }

  .loginPasswordField {
    position: relative;
  }

  .loginPasswordToggle {
    display: none;
  }

  @media (max-width: 767px) {
    html,
    body {
      overflow-x: hidden;
    }

    #app {
      min-height: 100dvh;
      padding-top: 0;
      overflow-x: hidden;
    }

    .loginPage {
      min-height: 100dvh;
      margin-top: 0 !important;
      padding:
        max(12px, env(safe-area-inset-top))
        max(12px, env(safe-area-inset-right))
        max(16px, env(safe-area-inset-bottom))
        max(12px, env(safe-area-inset-left));
      overflow-x: hidden;
      overflow-y: auto;
    }

    .loginContainer {
      min-height: calc(100dvh - max(12px, env(safe-area-inset-top)) - max(16px, env(safe-area-inset-bottom)));
      max-width: 100% !important;
      padding: 0 !important;
    }

    .loginRow {
      min-height: auto;
      margin: 0 !important;
      align-content: flex-start;
    }

    .loginRow > .col-12 {
      padding: 0 !important;
    }

    .loginCard {
      width: 100%;
      max-width: 393px;
      margin: 0 auto !important;
      overflow: hidden;
    }

    .loginCard .row {
      margin-left: 0;
      margin-right: 0;
    }

    .loginCard .col-12 {
      padding-left: 0;
      padding-right: 0;
    }

    .loginMobileLogoCard {
      height: 104px !important;
      border-radius: 0 !important;
    }

    .loginMobileLogo {
      width: 180px !important;
      max-width: 72vw !important;
    }

    .loginTitle {
      padding: 18px 18px 10px !important;
      font-size: 22px !important;
      line-height: 1.2 !important;
    }

    .loginFieldColumn {
      padding: 0 18px !important;
    }

    .loginFieldColumn .v-input {
      margin-top: 0;
    }

    .loginFieldColumn .v-input__slot {
      min-height: 48px !important;
    }

    .loginPasswordField .v-input__slot {
      padding-right: 50px !important;
    }

    .loginPasswordToggle {
      position: absolute;
      right: 18px;
      top: 0;
      z-index: 2;
      display: flex;
      width: 48px;
      height: 48px;
      align-items: center;
      justify-content: center;
      border: 0;
      background: transparent;
      color: #555;
      cursor: pointer;
    }

    .loginPasswordToggle .material-icons {
      font-size: 22px;
      line-height: 1;
    }

    .loginActions {
      padding: 0 18px 18px !important;
    }

    .loginActions .row {
      width: 100%;
      margin: 0 !important;
    }

    .loginButtonColumn {
      flex: 0 0 100%;
      max-width: 100%;
      padding: 0 !important;
    }

    .loginButtonColumn .v-btn {
      min-height: 48px;
      width: 100%;
    }

    .loginVersion {
      display: block;
      padding: 0 18px 14px;
      font-size: 11px;
      line-height: 1.3;
      word-break: break-word;
    }

    .v-dialog {
      max-width: calc(100vw - 24px) !important;
      margin: 12px !important;
    }
  }
</style>
